import styled from 'styled-components';
import { destInfoModifyListAtom } from './DestInfo';
import { useAtom } from 'jotai';
import { Badge, Button, InputAdornment, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import * as _ from 'lodash';
import CloseIcon from '@mui/icons-material/Close';
const MainContentWrap = styled.div`
  width: 100%;
  height: 100%;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 2rem;
  .row{
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 1rem;
  }
`;

interface ModInfo {
  work_time: [{ start: string; end: string }];
  dwell_time: number;
  priority: number | string;
  memo: string;
}

export default function MultiMode() {
  const [modifyInfo, setModifyInfo] = useAtom(destInfoModifyListAtom);
  const [form, setForm] = useState<ModInfo>();
  const [workTime, setWorkTime] = useState<{ start: string; end: string }>({ start: '', end: '' });
  useEffect(() => {
    if (modifyInfo && modifyInfo.length > 0) {
      setForm({
        work_time: modifyInfo[0].work_time,
        dwell_time: modifyInfo[0].dwell_time,
        priority: modifyInfo[0].priority,
        memo: modifyInfo[0].memo,
      });
    }
  }, [modifyInfo]);

  const handleSingleSaveClick = async () => {
    const temp = _.map(modifyInfo, (v: any) => {
      return {
        ...v,
        work_time: form.work_time,
        dwell_time: form.dwell_time,
        priority: form.priority,
        memo: form.memo,
      };
    });
    setModifyInfo(temp);
  };
  const handleAddWorkTimeClick = () => {
    if (workTime?.start !== '' && workTime?.end !== '') {
      const temp = form;
      const workTemp = temp.work_time;
      const checkItem = workTemp.find((target) => {
        if (target.start < workTime.start && target.end > workTime.start) return target;
        if (target.start < workTime.end && target.end > workTime.end) return target;
      });
      !checkItem && workTemp.push(workTime);
      setForm({ ...temp, work_time: _.orderBy(workTemp, ['start'], ['asc']) as [{ start: string; end: string }] });
      setWorkTime({ start: '', end: '' });
    }
  };

  const handleChangeWorkTime = (key: 'start' | 'end', val: string) => {
    const temp = { ...workTime };
    temp[key] = val;
    setWorkTime(temp);
  };

  const handleWorkTimeDelete = (index: number) => {
    const temp = [...form.work_time.slice(0, index), ...form.work_time.slice(index + 1, form.work_time.length)] as [
      { start: string; end: string },
    ];
    setForm({ ...form, work_time: temp });
  };

  return (
    <MainContentWrap>
      <div className="row">
        <TextField
          label="체류시간"
          size="small"
          type="number"
          sx={{ width: '6rem' }}
          value={form && form.dwell_time / 60}
          onChange={(e) => setForm({ ...form, dwell_time: Number(e.target.value) * 60 })}
          slotProps={{
            inputLabel: { shrink: true },
            input: {
              inputProps: { style: { textAlign: 'right' } },
              endAdornment: <InputAdornment position="end">분</InputAdornment>,
            },
          }}
        />
        <Button variant="contained" onClick={handleSingleSaveClick}>
          저장
        </Button>
      </div>
      <div className="row">
        <TextField
          label="배송가능시간(시작)"
          size="small"
          slotProps={{
            inputLabel: { shrink: true },
            input: {
              inputProps: { style: { textAlign: 'right' } },
            },
          }}
          sx={{ width: '6rem' }}
          value={workTime?.start}
          onChange={(e) => handleChangeWorkTime('start', e.target.value)}
        />{' '}
        ~
        <TextField
          label="배송가능시간(종료)"
          size="small"
          slotProps={{ inputLabel: { shrink: true } }}
          sx={{ width: '6rem' }}
          value={workTime?.end}
          onChange={(e) => handleChangeWorkTime('end', e.target.value)}
        />
        <Button variant="contained" onClick={handleAddWorkTimeClick}>
          추가
        </Button>
        {form &&
          form.work_time &&
          form.work_time.length > 0 &&
          form.work_time.map((work, index) => (
            <Badge key={index} badgeContent={<CloseIcon onClick={() => handleWorkTimeDelete(index)} />} color="error">
              <div
                style={{
                  background: 'rgba(82, 133, 164, 0.87)',
                  borderRadius: '0.75rem',
                  padding: '6px 12px',
                  color: '#ffffff',
                }}
              >
                {work.start}~{work.end}
              </div>
            </Badge>
          ))}
      </div>
      <div className="row">
        <TextField
          label="메모"
          sx={{ width: '80%' }}
          size="small"
          slotProps={{ inputLabel: { shrink: true } }}
          value={form && form.memo}
          onChange={(e) => setForm({ ...form, memo: e.target.value })}
        />
      </div>
    </MainContentWrap>
  );
}
